import PAGINATION from '@sdk/helpers/misc/pagination';

import client from '@/api/client';

import crudlModuleGenerator from '@/_CRUDL/modules/generator';

import { vehicleGroupKey } from '@sdk/views/Simulations/Form/vehicles';

export const VEHICLE_MODELS_GROUPED_START = '_CRUDL/vehicleModels/grouped/START';
export const VEHICLE_MODELS_GROUPED_SUCCESS = '_CRUDL/vehicleModels/grouped/SUCCESS';
export const VEHICLE_MODELS_GROUPED_FAILURE = '_CRUDL/vehicleModels/grouped/FAILURE';

export const INITIAL_VEHICLE_FILTERS = {
  CRUDL_append: false,
  active: '',
  publish: '',
  vehicle_type_id: '',
  fuel_id: '',
  vehicle_brand_id: '',
  year_start: '',
  year_end: '',
  has_molicar_code: '',
  has_fipe_code: '',
  q: '',
  name_molicar_fipe: '',
  page: 1,
  per_page: PAGINATION.PER_PAGE,
  show: false,
};

const vehicleModels = crudlModuleGenerator('vehicleModels', {
  customKeys: {
    list: 'vehicle_models',
  },
});

export default {
  ...vehicleModels,

  actions: {
    ...vehicleModels.actions,

    grouped({ commit }, payload) {
      commit(VEHICLE_MODELS_GROUPED_START);

      return new Promise((resolve, reject) => {
        client.get('/vehicle_models/grouped', {
          params: {
            ...payload,
          },
        })
          .then((response) => {
            commit(VEHICLE_MODELS_GROUPED_SUCCESS, response);
            resolve(response);
          })
          .catch((error) => {
            commit(VEHICLE_MODELS_GROUPED_FAILURE, error);
            reject(error);
          });
      });
    },
  },

  mutations: {
    ...vehicleModels.mutations,

    [VEHICLE_MODELS_GROUPED_START](state) {
      state.grouped.error = null;
      state.grouped.items = {};
      state.grouped.loading = true;
    },
    [VEHICLE_MODELS_GROUPED_SUCCESS](state, response) {
      state.grouped.error = null;
      state.grouped.items = response.data.vehicle_models.reduce((items, item) => {
        // eslint-disable-next-line no-param-reassign
        items[vehicleGroupKey(item)] = item;

        return items;
      }, {});
      state.grouped.loading = false;
    },
    [VEHICLE_MODELS_GROUPED_FAILURE](state, error) {
      let details = error;

      try {
        details = error.response.data.error;
      } catch (err) { /* */ }

      state.grouped.error = details;
      state.grouped.items = {};
      state.grouped.loading = false;
    },
  },

  state: {
    ...vehicleModels.state,

    grouped: {
      error: null,
      items: {},
      loading: false,
    },
    list: {
      ...vehicleModels.state.list,
      filters: {
        ...INITIAL_VEHICLE_FILTERS,
      },
    },
  },
};
